import React, { useState } from 'react';
import { Card, Input, Button, Typography, Space, App } from 'antd';
import { LockOutlined, CalculatorOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../stores/authStore';

const LoginPage: React.FC = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!password.trim()) return;
    setLoading(true);
    const ok = await useAuthStore.getState().loginDashboard(password);
    setLoading(false);
    if (!ok) message.error(t('idea_calc.login.msg_login_error'));
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f0f2f5',
      }}
    >
      <Card style={{ width: 360, textAlign: 'center' }}>
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
          <CalculatorOutlined style={{ fontSize: 48, color: '#1677ff' }} />
          <Typography.Title level={4} style={{ margin: 0 }}>
            {t('idea_calc.header.logo_title')}
          </Typography.Title>
          <Input.Password
            size="large"
            prefix={<LockOutlined />}
            placeholder={t('idea_calc.login.password')}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onPressEnter={handleLogin}
          />
          <Button
            type="primary"
            size="large"
            block
            loading={loading}
            onClick={handleLogin}
          >
            {t('idea_calc.login.submit')}
          </Button>
        </Space>
      </Card>
    </div>
  );
};

export default LoginPage;
